// extracted by mini-css-extract-plugin
module.exports = {"Icon":"Icon_Icon__2oPAu"};